<template>
  <div class="home body" id="home">
    <Banner/>
    <Border/>
    <Estadisticas/>
    <Ubicacion/>
    <Beneficios/>
    <Noticias/>
    <Clientes/>
    <FAQ/>
    <Contacto/>
    <router-link :to="{name: 'Home', hash: '#contactanos'}">
      <b-button class="desktop" v-if="lang == 'eng'">I'm interested</b-button>
      <b-button class="desktop" v-else-if="lang == 'esp'">Estoy interesado</b-button>

      <b-button class="mobile"><img src="../assets/img/icn_informes.svg" alt="Informes"></b-button>
    </router-link>
    <a href="https://wa.me/526647820935" target="_blank">
      <div class="whatsapp">
        <img src="../assets/img/icn_whatsapp.svg" alt="Whatsapp">
      </div>
    </a>
  </div>
</template>

<script>
  import Banner from './Banner'
  import Border from './Border'
  import Estadisticas from './Estadisticas'
  import Ubicacion from './Ubicacion'
  import Beneficios from './Beneficios'
  import Noticias from './Noticias'
  import Clientes from './Clientes'
  import FAQ from './FAQ'
  import Contacto from './Contacto'
  import {mapState, mapActions, mapMutations} from 'vuex'
  export default {
    computed:{
      ...mapState(['lang'])
    },
    components: {
      Banner,
      Border,
      Estadisticas,
      Ubicacion,
      Beneficios,
      Noticias,
      Clientes,
      FAQ,
      Contacto
    }
  }
</script>

<style scoped>
  .btn{
    background-color: #068C93!important;
    color: white!important;
    font-family: 'sailecBold';
    border-radius: 100px!important;
    font-size: 9pt!important;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
    -moz-box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
    box-shadow: 0px 5px 10px 0px rgba(56,163,169,1)!important;
    position: fixed;
    right: 15px;
    top: 200px;
  }  
  .mobile{
    display: none;
  }
  .whatsapp{
    width: 60px;
    position: fixed;
    right: 15px;
    bottom: 15px;
  }
  .whatsapp img{
    width: 100%;
  }

  @media screen and (max-width: 767px){
    .desktop{
      display: none;
    }
    .mobile{
      display: block;
    }
    .btn{
      padding: 10px;
      top: 100px;
    }
    .whatsapp{
      right: 10px;
      bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue